import projection from '../generated/pwj212f1.json';
import { AcceptanceManifest } from '../types';

export const pwj212f1AcceptanceManifest = projection as AcceptanceManifest;
